import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'fcp-toggle-switch',
    templateUrl: './fcp-toggle-switch.component.html',
    styleUrls: ['./fcp-toggle-switch.component.less'],
    standalone: false
})
export class FcpToggleSwitchComponent {
    @Input() isActive: boolean;
    @Input() size: Size = Size.Medium;
    @Input() disabled = false;
    @Output() statusChange = new EventEmitter<boolean>();
}

export enum Size {
    Small = 'small',
    Medium = 'medium'
}
